import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import { Controller, Control, FormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line camelcase
import type { IAvailableUsersAvailableUsers as AvailableUser } from '../../api/generated/models';
import useStyles from "./AddInputsStyle"

interface IEditProps {
    control: Control<any>,
    formS: FormState<any>,
    users: AvailableUser[]
}

const AddInputs: React.FC<IEditProps> = ({ control, formS, users }) => {
    const { t } = useTranslation('common');
    const classes = useStyles();

    return (
        <div>
            <FormControl className={classes.formControlStyle}>
                <InputLabel variant="standard">{t("user")}</InputLabel>
                <Controller
                    name="userId"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                        <Select {...field} label={t("user")} variant="standard">
                            {users.map(u => (
                                <MenuItem key={u.providerUserId} value={u.providerUserId ?? ''}>
                                    {u.username}
                                </MenuItem>
                            ))}
                        </Select>
                    )}
                />
            </FormControl>
            <div className={classes.err}>
                {formS.errors && typeof formS.errors.userId?.message === 'string' ? t(formS.errors.userId.message) : null}
            </div>
        </div>
    );
}

export default AddInputs
